import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { StockData } from "../commonTocConstant";
import TocMarketDepth from "./TocMarketDepth";
import { useSelector } from "react-redux";
import di from "@di";
import { isEqual } from "underscore";
import { useParams } from "react-router-dom";
export const placeorderData = [
    { value: "BSE", display: "BSE" },
    { value: "NSE", display: "NSE" },
];
export const placeorderDataMCX = [
    { value: "MCX", display: "MCX" },
];
export const placeorderDataNCDEX = [
    { value: "NCDEX", display: "NCDEX" },
];
export const placeorderDataCurrency = [
    { value: "CDS", display: "CDS" },
];
const MarketDepthTabs = (props) => {
    const device = DeviceContext();
    const params = useParams();
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity, isEqual);
    const [scriptDetails, setScriptDetails] = useState({});
    const TabContent = (key) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(TocMarketDepth, { scriptData: scriptDetails })));
    };
    const handelTabChange = (tab) => {
        var _a, _b, _c;
        const payload = {
            symbol: tab == ((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange)
                ? (_b = quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.symbol
                : (_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.asSymbol,
        };
        di.common.returnScriptData(payload).then((data) => {
            setScriptDetails(data);
        });
    };
    React.useEffect(() => {
        if ((device === null || device === void 0 ? void 0 : device.isMobile) && (params === null || params === void 0 ? void 0 : params.symbol)) {
            handelTabChange(props.nseBse);
        }
    }, [props.nseBse]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-3" },
            React.createElement(Col, { lg: 12 }, !(props === null || props === void 0 ? void 0 : props.isTabHide) ? (React.createElement(GenericTabs, { externalClassName: "common-tab-color", defaultActiveKey: props.nseBse, tabsArray: StockData.map((tab) => {
                    return {
                        title: tab.title,
                        eventKey: tab.eventKey,
                        tabContent: TabContent(tab.eventKey),
                    };
                }), callBackFunction: (tab) => {
                    handelTabChange(tab);
                } })) : (React.createElement(React.Fragment, null, TabContent("")))))));
};
export default MarketDepthTabs;
